import * as React from "react";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent/DataBaseComponent";
import {DialogLayout} from "components/DialogLayout/DialogLayout";
import {ActionButton, ActionButtonType} from "components/Button/ActionButton";
import Dialog from "components/Dialog/Dialog";

interface DeleteDialogProps {
    open: boolean;
    title: string;
    deleteButtonLabel?: string;
    deleteButtonBusyLabel?: string;
    deleteButtonType?: ActionButtonType;

    onDeleteClick(): boolean | Promise<boolean>;

    onClose(): any;
}

export default class DeleteDialog extends DataBaseComponent<DeleteDialogProps, DataBaseComponentState> {
    constructor(props: DeleteDialogProps) {
        super(props);
        this.state = {};
    }

    onDeleteClick() {
        return this.doBusyTask(async () => {
            const result = await this.props.onDeleteClick();
            if (result) {
                this.props.onClose();
            }
        });
    }

    render() {
        const del = <ActionButton key="Continue"
                                  label={this.props.deleteButtonLabel || "Delete"}
                                  type={ActionButtonType.Delete}
                                  busyLabel={this.props.deleteButtonBusyLabel || "Deleting..."}
                                  disabled={this.state.busy}
                                  onClick={() => this.onDeleteClick()}/>;

        const cancel = <ActionButton key="Cancel" label="Cancel"
                                     disabled={this.state.busy}
                                     onClick={() => this.props.onClose()}/>;

        return <Dialog open={this.props.open || false}>
            <DialogLayout actions={[cancel, del]}
                          title={this.props.title}
                          busy={this.state.busy}
                          closeDialog={this.props.onClose}
                          errors={this.state.errors}>
                {this.props.open && this.props.children}
            </DialogLayout>
        </Dialog>;
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Dialog/DeleteDialog.tsx